import {parseBotResponse, scanUrl} from './utils.js';

window.mashbot = {
  utils: {
    scanUrl,
    parseBotResponse
  }
}


